import { ChevronUpIcon } from '@heroicons/react/solid';
import clsx from 'clsx';

export type PageTopButtonProps = {
  className?: string;
};

const returnToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export const PageTopButton = ({ className }: PageTopButtonProps) => {
  return (
    <button
      className={clsx(
        'flex flex-col items-center focus:outline-none',
        'transition ease-in duration-200 transform hover:-translate-y-2',
        className
      )}
      onClick={returnToTop}
    >
      <ChevronUpIcon className="h-12 md:h-16" />
      <p className="text-sm md:text-base">PAGE TOP</p>
    </button>
  );
};
